import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Buy() {
  const navigate = useNavigate();

  // Telegram back button
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg) {
      tg.BackButton.show();
      tg.BackButton.onClick(() => navigate(-1));
      return () => {
        tg.BackButton.hide();
        tg.BackButton.offClick(() => navigate(-1)); // Отписываемся от события
      };
    }
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <h1 className="text-2xl text-white font-bold">Страница покупки</h1>
    </div>
  );
}